var React = require('react');

function DifficultyLevelGreenOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"difficulty-level-green-outline"),React.createElement("circle",{"fill":"#4CA252","stroke":"#000","strokeMiterlimit":"10","cx":"11","cy":"11","r":"10.5","key":1})]);
}

DifficultyLevelGreenOutline.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 22 22"};

module.exports = DifficultyLevelGreenOutline;

DifficultyLevelGreenOutline.default = DifficultyLevelGreenOutline;
